<!-- 选择工具 -->
<template>
  <div class="pb76 box-eval-create" v-loading="loading">
    <!-- 未创建好测评时允许切换评估模式 -->
    <yxt-form
      v-if="supportBehavior && modelId && skillLevel"
      ref="form"
      :model="form"
      label-width="76px"
      label-position="top"
      class="select-tool-form"
    >
      <yxt-blockhead :title="$t('pc_biz_eval_lbl_evaluation_mode' /* 评估模式 */)" size="small" type="special" />
      <yxt-form-item
        prop="type"
        class="select-tool-item"
      >
        <yxt-radio-group
          v-model="form.type"
          @change="changeType"
        >
          <!-- 测评方案信息保存后，评估模式无法二次编辑 -->
          <yxt-tooltip :content="$t('pc_biz_eval_msg_mode_not_editable_after_save')" placement="top" :disabled="!disabledToolChange">
            <yxt-radio :label="2" :disabled="!!disabledToolChange">
              {{ $t('pc_gwnl_eval_toolEval').d('工具评估') }}
            </yxt-radio>
          </yxt-tooltip>

          <!-- 测评方案信息保存后，评估模式无法二次编辑 -->
          <yxt-tooltip :content="$t('pc_biz_eval_msg_mode_not_editable_after_save')" placement="top" :disabled="!disabledBehaviorChange">
            <yxt-radio :label="1" :disabled="!!disabledBehaviorChange">
              {{ $t('pc_gwnl_eval_behavioralEval').d('行为评估') }}
            </yxt-radio>
          </yxt-tooltip>
        </yxt-radio-group>
      </yxt-form-item>
    </yxt-form>
    <template v-if="form.type === 2">
      <div class="mb16 mr24 flex align-items-center justify-between">
        <div v-if="!isQueCreateHidden">
          <yxt-button type="primary" @click="toCreateSurvey">{{$t('pc_gwnl_eval_btn_newTool').d('新建工具')}}</yxt-button>
        </div>
        <div>
          <!-- 选择权限 -->
          <yxt-select
            v-if="isShowRangeSelect"
            v-model="dataPermsType"
            class="mr12 width160"
            clearable
            :placeholder="$t('pc_gwnl_global_please_selected' /*请选择*/)"
            size="small"
            @change="searchByKewords"
          >
            <yxt-option v-for="item in evalDataRanges" :key="item.value" :label="item.label" :value="item.value" />
          </yxt-select>
          <!-- 选择层级 -->
          <yxt-select
            v-model="dataParamsLeval"
            class="mr12 width160"
            :placeholder="$t('pc_gwnl_eval_selectLevel')"
            clearable
            size="small"
            @change="searchByKewords"
          >
            <yxt-option
              v-for="item in surveyLevel"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </yxt-select>
          <yxt-input
            v-model="keywords"
            style="width: 220px;"
            size="small"
            :placeholder="$t('pc_gwnl_eval_enterToolName').d('请输入工具名称进行搜索')"
            searchable
            clearable
            @keyup.enter.native="searchByKewords"
            @search="searchByKewords"
          />
        </div>
      </div>
      <div v-if="!isQueCreateHidden" class="mb16 mr24">
        <yxt-alert v-if="modelId" bg-color="#F5F5F5" :closable="false">
          <template slot="title">
            <!-- 测训的可以不选模型 -->
            <span class="color-gray-9">
              {{ (beforeId || isAfterTest)
                ? $t('pc_eval_tit_tooltip' /* 仅展示与本项目的前测项目所用工具同模型的测评工具 */)
                : $t('pc_gwnl_trainingEval_selectToolTips' /* 工具选择，仅支持选择与项目能力模型相同的测评工具 */) }}
            </span>
          </template>
        </yxt-alert>
      </div>
      <div class="select_table_wrap">
        <div class="gwnl-eval-select-util flex flex-wrap" v-if="utils.length && !loading">
          <!-- 5.4需求不控制额度为0的勾选 -->
          <!-- :disabled="util.availableNum === 0 && util.charged !== 0" -->
          <yxtbiz-eval-card
            v-for="util in utils"
            :key="util.surveyId"
            :active="util.selected"
            @click.native="selectUtil(util)"
          >
            <template #top>
              <div class="eval-custom-text">
                <span class="tag">
                  <template v-if="util.surveyType === 1">
                    {{ $t('pc_gwnl_eval_personalityAssessment') }}
                  </template>
                  <template v-else-if="util.peerAssess !== 1">
                    {{ $t('pc_gwnl_eval_only_slef') }}
                  </template>
                  <template v-else>
                    {{ $t('pc_gwnl_eval_360eval') }}
                  </template>
                </span>

                <span v-if="!!util.charged && util.surveySource === 4" class="eval-ai-icon ml8">
                <yxt-svg
                  :remote-url="aiSvgPath"
                  width="16px"
                  height="16px"
                  icon-class="ai-icon" />
              </span>
              </div>
              <span>
                <template v-if="util.charged === 0">
                  {{ $t('pc_gwnl_eval_available_aredit') }}：{{ $t('pc_gwnl_global_unlimited') }}
                </template>
                <template v-else>
                  {{ $t('pc_gwnl_eval_available_aredit') }}：
                  <span>{{ util.availableNum }}</span>
                  /{{ util.surveyNumTotal }}
                </template>
              </span>
            </template>
            <template #title>
              <yxt-tooltip :manual="true" effect="dark" :content="util.surveyName" placement="top-start">
                <span class="font-bolder">{{ util.surveyName }}</span>
              </yxt-tooltip>
            </template>
            <template #level>
              <div class="flex">
                <span class="color-gray-7">{{ $t('pc_gwnl_eval_hierarchy' /* 层级 */) }}：</span>
                <yxt-tooltip :open-filter="true" effect="dark" :content="util.surverLevelText" placement="top-start">
                  <span class="color-gray-9 ellipsis flex-1"> {{ util.surverLevelText }} </span>
                </yxt-tooltip>
              </div>
              <div class="flex mt8">
                <span class="color-gray-7">{{ $t('pc_gwnl_eval_purpose' /* 用途 */) }}：</span>
                <yxt-tooltip :open-filter="true" effect="dark" :content="util.purpose" placement="top-start">
                  <span class="color-gray-9 ellipsis flex-1"> {{ util.purpose }} </span>
                </yxt-tooltip>
              </div>
            </template>
          </yxtbiz-eval-card>
        </div>
        <div class="clearfix mr24">
          <yxtbiz-eval-pager
            :total.sync="pager.total"
            :page.sync="pager.offset"
            :limit.sync="pager.limit"
            @pagination="getUtils"
          >
          </yxtbiz-eval-pager>
        </div>
        <yxt-empty class="mt100" v-if="!utils.length && !loading" :empty-text="$t('pc_gwnl_selectUtils_empty_text'/*  您还没有可以使用的测评工具～  */)"/>
      </div>
    </template>
    <template v-else>
      <!-- 传入允许多次行为评估 & 目前支持前后测关联不支持多次行为评估 -->
      <template v-if="isMultiEval && !beforeId && !isAfterTest">
        <yxt-form
          label-width="76px"
          label-position="top"
        >
          <yxt-blockhead :title="$t('pc_gwnl_eval_evalType').d('评估类型')" size="small" type="special" />
          <yxt-form-item>
            <div class="flex mt16 ml16">
              <div class="eval-select-util__card" :class="{'is-active': !isMultiBehavior}" @click="isMultiBehavior = false">
                <div class="eval-select-util__card-title">
                  <img src="https://stc.yxt.com/assets/e422e025/7c5cdb75/23fb42.svg" alt="">
                  <span class="ml4">{{ $t('pc_talent_title_single_eval').d('单次评估') }}</span>
                </div>
                <div>{{ $t('pc_talent_msg_single_eval').d('常规评估模式，一个任务下针对能力模型进行一次性评估。') }}</div>
              </div>
              <div class="eval-select-util__card ml16" :class="{'is-active': isMultiBehavior}" @click="isMultiBehavior = true">
                <div class="eval-select-util__card-title">
                  <img src="https://stc.yxt.com/assets/e422e025/7c5cdb75/676918.svg" alt="">
                  <span class="ml4">{{ $t('pc_talent_title_multi_eval').d('多次评估') }}</span>
                </div>
                <div>{{ $t('pc_talent_msg_multi_eval').d('对于能力模型，可以进行多次评估按照规则设置，进行第二次评估触达，全面反复的进行能力评定。') }}</div>
              </div>
            </div>
          </yxt-form-item>
        </yxt-form>
      </template>
      <div class="eval_action_empty">
        <div>
          <img width="410" height="240" :src="`${this.$staticBaseUrl}ufd/b0174a/evaluation/pc/img/eval_action_empty.png`" alt="">
        </div>
        <header> {{ $t('pc_gwnl_eval_behavioralEval') }}</header>
        <p>{{$t('pc_gwnl_eval_behavioralEval_des')}}</p>
      </div>
    </template>
    <yxtbiz-eval-step-footer :operation="operation" footer-width="960px" />
  </div>
</template>

<script>
import { getEvalUtils, getModelById, getDataPermission } from './service.js';
import permisson from './config/permission';
import evalPager from './components/eval-pager';
import evalStepFooter from './components/eval-step-footer';
import evalCard from './components/eval-card';

const MODEL_HAS_LEVEL = {
  yes: 1,
  no: 0
};
export default {
  props: {
    isMultiEval: {
      type: Boolean,
      default: false
    },
    purposeId: {
      type: String,
      default: ''
    },
    sourceType: {
      type: Number
    },
    id: {
      type: String,
      default: ''
    },
    modelId: {
      type: String,
      default: ''
    },
    surveyId: {
      type: String,
      default: ''
    },
    // 是否支持行为评估
    supportBehavior: {
      type: Boolean,
      default: false
    },
    // 能力模型是否有等级
    skillLevel: {
      type: [Number, Boolean],
      default: false
    },
    // 评估方案场景(1-胜任力 2-人格 3-通用)
    scene: {
      type: Number,
      default: 1
    },
    // 评估类型 1：行为评估，2：问卷评估
    type: {
      type: Number,
      default: 2
    },
    isQueCreateHidden: {
      type: Number,
      default: 0
    },
    // 前测的 id
    beforeId: {
      type: String,
      default: ''
    },
    isAfterTest: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      surveyPurpose: this.genSurveyPurpose(),
      enableSkillLevel: 1, // 能力模型是否有等级(0-否,1-是)
      form: {
        type: this.type
      },
      operation: {
        disabled: false,
        nextDisabled: false,
        cancel: this.cancel,
        next: this.next
      },
      pager: {
        limit: 20,
        offset: 0,
        total: 0
      },
      keywords: '',
      utils: [],
      surveyLevel: this.genSurveyLevel(),
      selectedUtil: null,
      loading: false,
      evalDataRanges: [
        {
          value: 0,
          label: this.$t('pc_gwnl_web_creator' /* 我创建的 */)
        },
        {
          value: 1,
          label: this.$t('pc_gwnl_web_imInCharge' /* 我管辖的 */)
        }
      ],
      dataParamsLeval: '',
      dataPermsType: '',
      isShowRangeSelect: 0,
      isMultiBehavior: false,
      aiSvgPath: 'https://stc.yxt.com/ufd/55a3e0/speval/pc/svg'
    };
  },

  components: {
    yxtbizEvalPager: evalPager,
    yxtbizEvalStepFooter: evalStepFooter,
    yxtbizEvalCard: evalCard
  },

  computed: {
    hasLevel() {
      return this.enableSkillLevel === MODEL_HAS_LEVEL.yes;
    },

    disabledToolChange() {
      return this.id && this.form.type === 1;
    },

    disabledBehaviorChange() {
      return this.id && this.form.type === 2;
    }
  },

  mounted() {
    if (this.modelId) {
      getModelById(this.modelId).then((res) => {
        if (!res) return;

        if ('enableSkillLevel' in res) {
          this.enableSkillLevel = res.enableSkillLevel;
        }
      }).catch(e => console.log(e));
    }
  },

  async created() {
    if (this.type === 4) {
      this.form.type = 1;
      this.isMultiBehavior = true;
    } else {
      this.form.type = this.type;
    }
    await this.initRange();
    this.getUtils();
  },

  methods: {
    async initRange() {
      await getDataPermission().then(res => {
        const { dataPermissionList } = res;
        if (dataPermissionList) {
          const data = dataPermissionList.find(item => item.code === 'eval');
          if (data) this.isShowRangeSelect = data.dataPermission;
        }
      }).catch(() => {
        this.isShowRangeSelect = 0;
      });
    },
    // 重置分页
    resetPagination() {
      this.pager.offset = 0;
    },
    searchByKewords() {
      this.resetPagination();
      this.getUtils();
    },

    // 用途
    genSurveyPurpose() {
      return [
        {
          name: this.$t('pc_gwnl_eval_talent_inventory'),
          code: '1',
          alias: 'rencai'
        },
        {
          name: this.$t('pc_gwnl_eval_competitive_selection'),
          code: '2',
          alias: 'xuanba'
        },
        {
          name: this.$t('pc_eval_lbl_people_develop'),
          code: '3',
          alias: 'fazhan'
        },
        {
          name: this.$t('pc_gwnl_eval_scene_purpose_campusRecruitment'), // 校园招聘
          code: '4',
          alias: 'school'
        },
        {
          name: this.$t('pc_gwnl_eval_scene_purpose_socialRecruitment'), //  社会招聘
          code: '5',
          alias: 'society'
        }
      ];
    },
    // 问卷层级
    genSurveyLevel() {
      return [
        {
          name: this.$t('pc_gwnl_eval_general'),
          code: '1'
        },
        {
          name: this.$t('pc_gwnl_eval_fresh_student'),
          code: '2'
        },
        {
          name: this.$t('pc_gwnl_eval_professional'),
          code: '3'
        },
        {
          name: this.$t('pc_gwnl_eval_basic_admin'),
          code: '4'
        },
        {
          name: this.$t('pc_gwnl_eval_middle_admin'),
          code: '5'
        },
        {
          name: this.$t('pc_gwnl_eval_high_admin'),
          code: '6'
        }
      ];
    },
    changeType(type) {
      // 选中行为评估清空选中问卷
      this.$emit('changeAssess', this.form.type);
    },
    getUtils() {
      if (this.loading) return;
      let params = {
        navCode: permisson.centerCode,
        dataPermsCode: permisson.center.data.eval_tools_list_get_extent,
        status: 1,
        surveyLevel: this.dataParamsLeval,
        surveyType: -1, // 问卷类型(0:通用, 1:人格, -1:全部)
        modelId: this.modelId,
        searchKey: this.keywords.trim(),
        dataPermsType: this.dataPermsType === '' ? null : this.dataPermsType,
        dataPermissionSwitch: this.isShowRangeSelect,
        limit: this.pager.limit,
        offset: this.pager.offset,
        showAiSurvey: 0 // 5.4隐藏ai工具
      };
      // 有模型传问卷用途
      // if (this.modelId) {
      //   params.surveyPurpose = 3; // 问卷用途 1:人才盘点、2:竞聘选拔、3:培养发展
      // }

      params.surveyPurpose = this.purposeId;

      this.loading = true;
      getEvalUtils(params).then(res => {
        this.loading = false;
        this.utils = this.formatData(res.datas);
        this.setSelectedUtil();
        this.pager.total = res.paging.count;
      }).catch(() => {
        this.loading = false;
      });
    },
    formatData(data) {
      if (!data) return [];

      const ret = data.map(item => {
        const surverLevelText = item.surveyLevel
          ? item.surveyLevel.split(',').map(one => {
            return this.surveyLevel.filter(obj => obj.code === one)[0].name;
          }).join('，')
          : '';

        const purposeText = item.surveyPurpose
          ? item.surveyPurpose.split(',').map(one => {
            return this.surveyPurpose.filter(obj => obj.code === one)[0].name;
          }).join('，')
          : '';

        let selected = false;
        if (this.selectedUtil && this.selectedUtil.surveyId === item.surveyId) {
          selected = true;
        }

        return {
          ...item,
          surverLevelText,
          purpose: purposeText,
          selected
        };
      });

      return ret;
    },
    selectUtil(item) {
      // 禁用状态不可选中
      // if (item.charged !== 0 && !item.availableNum) return;
      if (!item.selected) {
        this.utils.forEach(obj => {
          if (obj.selected) obj.selected = false;
        });

        item.selected = true;
        this.selectedUtil = item;
      }
    },
    // 处理默认选中问卷
    setSelectedUtil() {
      this.utils.forEach(item => {
        if (item.surveyId === this.surveyId) {
          item.selected = true;
          this.selectedUtil = item;
        }
      });
    },
    cancel() {
      this.$emit('cancel');
    },
    next() {
      if (!this.selectedUtil && this.form.type === 2) {
        this.$message.error(this.$t('pc_gwnl_msg_notSelectSurvey'/* 您还未选择问卷～ */));
        return;
      }
      if (this.form.type === 1) {
        this.$emit('update:surveyId', '');
        this.$emit('changeAssess', this.isMultiBehavior ? 4 : 1);
        this.selectedUtil = null;
        this.$emit('update:scene', 1);
      } else {
        const { surveyId, surveyType } = this.selectedUtil;
        this.$emit('changeAssess', this.form.type);
        this.$emit('update:surveyId', surveyId);
        // surveyType 0.通用，1.人格
        // scene 2 -人格，3-通用
        this.$emit('update:scene', surveyType === 1 ? 2 : 3);
      }
      this.$emit('next');
    },
    toCreateSurvey() {
      const modelId = this.modelId || '';
      let url = `${window.location.protocol}//${window.location.host}/sp/speval/#/eval/questionnaire/info`;
      let ret = `?model=${modelId}&purpose=${this.purposeId}`;
      if (url.includes('localhost:8086')) {
        return window.open('https://sip-phx.yunxuetang.com.cn/' + 'sp/speval/#/eval/questionnaire/info' + ret);
      }
      window.open(url + ret);
    }
  }
};
</script>
<style lang="scss">
.gwnl-eval-select-util {
  margin-left: -24px;
  margin-bottom: -24px;

  .talent-eval-card {
    margin-left: 24px;
    margin-bottom: 24px;

    .tag {
      height: 20px;
      padding: 0 4px;
      font-size: 12px;
      line-height: 20px;
      color: #8c8c8c;
      text-align: center;
      border: 1px solid #d0d0d0;
      border-radius: 2px;
    }
  }
}

</style>
<style lang="scss" scoped>
.box-eval-create {
  .eval_action_empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 15vh;
  }
  header {
    height: 32px;
    font-size: 24px;
    font-weight: 500;
    color: #262626;
    line-height: 32px;
  }

  p {
    height: 24px;
    font-size: 14px;
    font-weight: 400;
    color: #8C8C8C;
    line-height: 24px;
    margin-top: 8px;
    margin-bottom: 48px;
  }
  .gwnl-eval-select-util {
    margin-left: -24px;
    margin-bottom: -24px;

    .talent-eval-card {
      margin-left: 24px;
      margin-bottom: 24px;
    }
  }
}
.eval-select-util__card {
  position: relative;
  border: 1px solid #E9E9E9;;
  border-radius: 4px;
  width: 294px;
  line-height: 22px;
  padding: 16px 20px 20px 20px;
  color: #8C8C8C;
  font-size: 12px;
  line-height: 20px;
  background: url(https://stc.yxt.com/ufd/b0174a/evaluation/pc/img/reportBackground.png) no-repeat 100% 0,linear-gradient(213deg,#fafbff,#fff 100%,#fff 0);
  background-size: 110px 84px;
  cursor: pointer;

  &:hover {
    border: 1px solid #436BFF;
  }
  &-title {
    display: flex;
    font-size: 16px;
    font-weight: 500;
    color: #262626;
    line-height: 24px;
    margin-bottom: 8px;
  }
  &.is-active {
    border: 1px solid #436BFF;
    &::after {
      position: absolute;
      content: '';
      right: 0;
      bottom: 0;
      width: 34px;
      height: 32px;
      background: url(https://stc.yxt.com/ufd/b0174a/evaluation/pc/svg/util_selected2.svg) 0 0 no-repeat;
      background-size: 34px 32px;
    }
  }
}

.select-tool-item{
  margin-bottom: 24px !important;

  ::v-deep .yxt-form-item__label{
    height: 40px;
  }
}

.select_table_wrap {
  padding-bottom: 56px;
}
</style>
